// 2021-06-20 CHP Change config from config to static/config in order to change it anytime
// 2022-01-01 CHP 增加vue-meta

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Meta from 'vue-meta' // 2022-01-01 CHP 增加，用于SEO
import App from './App'
import router from './router'
import store from './store/store'

import 'mint-ui/lib/style.css'
import '@/assets/fonts/font.css'
import 'element-ui/lib/theme-chalk/index.css'
import { Carousel, CarouselItem, Card } from 'element-ui'
import {LogUtils, Storage} from '@/utils'
import VueI18n from 'vue-i18n'
import plusExtends from '@/config/plus.js'
Vue.prototype.$plus = plusExtends

// axios.defaults.baseURL = config.baseURL // 2021-06-20 C0025 Add

Vue.config.productionTip = false

// 2022-03-05 CHP 增加引入Carousel和CarouselItem
Vue.use(Carousel).use(CarouselItem).use(Card).use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'EN', // todo 使用版本
  fallbackLocale: 'EN',
  messages: { // todo 配置不同版本
    'EN': require('./assets/locale/en-US.js'),
    'IN': require('./assets/locale/hi-IN.js')
  }
})

/***
 * Execute something when enter each router
 * ......
 * 2021-06-08 CHP Add logic to send visit log to server
 * 2021-09-06 CHP 修改获取QueryString参数的方法，用to.query.xxx
 * 2021-10-24 LBL 如果是PC浏览器，跳转到web
 * 2021-10-25 CHP 根据用户特性决定用户所属国家版本
 * 2021-10-31 CHP 增加setShowInternationDDL判断是否需要显示国家列表
 * 2021-11-29 CHP 梳理IsAppCid判断逻辑
 */
router.beforeEach((to, from, next) => {
  // start 2021-7-30 C007 在Deposit页面
  document.getElementById('loading').style.display = 'none'
  // end 2021-07-30
  if (to.query.cid) {
    // 2022-02-20 CHP Cid统一转为小写
    let cidQ = to.query.cid.toLowerCase()
    // 2022-05-10 CHP 来自PartnerMatrix的cid为xxxx_xxxx,只取前半部分
    if (cidQ.indexOf('_') > 0) {
      let cidQL = cidQ.split('_')
      if (cidQL.length > 0) {
        cidQ = cidQL[0]
      }
    }
    localStorage.setItem('cid', cidQ)
  }

  let cid = localStorage.getItem('cid') // 注：从localstorage取出cid）

  // START 2021-11-29 CHP 重新梳理AppCid判断逻辑
  if (cid) {
    // 2021-11-19 WXJ 增加是否是app渠道开头的应用
    const isAppCid = typeof (cid) === 'string' && cid.startsWith('app')
    localStorage.setItem('isAppCid', isAppCid)
    store.commit('setIsAppCid', isAppCid)
  }

  if (to.query.v) {
    localStorage.setItem('apkV', to.query.v)
  }
  // 2022-06-21 CHP 重构国家版本语言设置
  setInternation()

  // 2022-06-21 CHP 重构LogVisit代码
  LogUtils.logVisit(location, to)
  // document.addEventListener('visibilitychange', logHandler)

  // 2022-06-21 CHP 召回检查
  // 2022-11-30 HHY 重新加载检查用户是否为回归用户
  LogUtils.checkCallback()

  let visibleCallback = function (ev) {
    if (!document.hidden || ev.type === 'DOMContentLoaded') {
      ev.stopPropagation()
      return false
    }
  }
  document.addEventListener('DOMContentLoaded', visibleCallback)
  // END 2021-12-14 WXJ 增加切换Bonus显示

  // 谷歌统计
  window.gtag('config', 'G-7BVS71WNE2', {'page_path': location.pathname})
  window.gtag('event', 'Visits', {
    'event_category': location.pathname,
    'event_label': cid
  })

  next()
})

/****
 * 页面路由切换完成
 * 2021-07-02 C007 Create
 */
router.afterEach((to, from) => {
  if (localStorage.getItem('hasNewVersion') === '1') {
    localStorage.removeItem('hasNewVersion')
    window.location.reload(true)
  }
})

/***
 * 设置国家版本
 * 2022-06-21 CHP 重构
 * 2023-05-24 WXJ 新需求
 */
const setInternation = function () {
  let locale = Storage.getExpire('locale')

  if (!locale) {
    locale = navigator.language.toUpperCase()
    if (locale === 'HI') {
      locale = 'IN'
    }
    if (locale !== 'EN' && locale !== 'IN') {
      locale = 'EN'
    }
    Storage.setExpire('locale', locale, 7 * 24 * 60 * 60)
  } else {
    locale = Storage.getExpire('locale')
    Storage.setExpire('locale', locale, 30 * 24 * 60 * 60)
  }
  let internation = 'IN'
  if (locale === 'IN') {
    internation = 'IN'
  }
  store.commit('setInternation', internation)
  // store.commit('setInternationName', res.InternationName)
  store.commit('setLocale', locale)
  i18n.locale = locale
}

/***
 * 检查用户7天送状态
 * 2022-06-21 CHP 重构
 * 2022-11-24 HHY 去掉使用state.finishUserGuide
 */
Vue.use(Meta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
}) // 2022-01-01 CHP 增加，用于SEO

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js